module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex < _vm.totalQuestions),
      expression: "currentQindex < totalQuestions"
    }],
    attrs: {
      "id": "score"
    }
  }, [_vm._v("\n    question " + _vm._s(_vm.currentQindex + 1) + " / " + _vm._s(_vm.totalQuestions) + "     score " + _vm._s(_vm.currentScore) + " / " + _vm._s(_vm.totalQuestions * 2) + "\n  ")]), _vm._v(" "), _vm._l((_vm.randomQuestions), function(q, index) {
    return _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.currentQindex),
        expression: "index === currentQindex"
      }]
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.debug === true),
        expression: "debug === true"
      }],
      staticClass: "debug"
    }, [_vm._v("\n        (DEBUGGING - ANSWERS SHOWN)"), _c('br'), _vm._v("\n        volume: " + _vm._s(q.volume)), _c('br'), _vm._v("\n        uncertainty: " + _vm._s(q.uncertainty)), _c('br'), _vm._v("\n        cylinder total: " + _vm._s(q.total)), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "question"
    }, [_c('div', {
      staticClass: "cylinder",
      class: {
        looking: _vm.isLooking[index]
      }
    }, [_c('button', {
      staticClass: "btn alt",
      on: {
        "click": function($event) {
          _vm.lookOn(index)
        }
      }
    }, [_vm._v("Get a closer look")]), _vm._v(" "), _c('img', {
      attrs: {
        "src": 'static/' + q.cylinder,
        "alt": q.name,
        "width": "126",
        "height": "511"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "closer-look"
    }, [_c('img', {
      attrs: {
        "src": 'static/' + q.zoom,
        "alt": q.name + ' zoom',
        "width": "316",
        "height": "316"
      }
    }), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.lookOff(index)
        }
      }
    }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.halfStep === false && _vm.finalStep === false),
        expression: "halfStep === false && finalStep === false"
      }],
      staticClass: "guesses",
      class: {
        neutral: !_vm.firstWrong, wrong: _vm.firstWrong
      }
    }, [_c('p', {
      staticClass: "neutral"
    }, [_vm._v("Select the most accurate volume.")]), _vm._v(" "), _c('p', {
      staticClass: "wrong"
    }, [_vm._v("Incorrect! But, you can still earn a point by determining the uncertainty value for the correct measurement.")]), _vm._v(" "), _vm._l((q.options), function(o, i) {
      return _c('div', {
        staticClass: "guess-option",
        class: 'guess-option_' + index
      }, [_c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.guessVolume[index]),
          expression: "guessVolume[index]"
        }],
        attrs: {
          "name": index + '_guess-option',
          "id": index + '_' + i,
          "type": "radio",
          "disabled": _vm.firstWrong === true,
          "autocomplete": "off"
        },
        domProps: {
          "value": o,
          "checked": _vm._q(_vm.guessVolume[index], o)
        },
        on: {
          "change": _vm.checkVolumeGuess,
          "__c": function($event) {
            _vm.$set(_vm.guessVolume, index, o)
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": index + '_' + i
        }
      }, [_vm._v(_vm._s(o) + " mL")])])])
    }), _vm._v(" "), _c('button', {
      staticClass: "guess btn neutral",
      on: {
        "click": _vm.submitAnswer
      }
    }, [_vm._v("Submit Answer")]), _vm._v(" "), _c('button', {
      staticClass: "guess btn wrong",
      on: {
        "click": _vm.continueWrong
      }
    }, [_vm._v("Continue")])], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.halfStep === true && _vm.finalStep === false),
        expression: "halfStep === true && finalStep === false"
      }],
      staticClass: "guesses"
    }, [_c('p', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.firstWrong === false),
        expression: "firstWrong === false"
      }]
    }, [_vm._v("Correct! Now, determine the uncertainty value for the measurement.")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.firstWrong === true),
        expression: "firstWrong === true"
      }]
    }, [_vm._v("Incorrect! But, you can still earn a point by determining the uncertainty value for the correct measurement.")])]), _vm._v(" "), _c('div', {
      staticClass: "uncertainty-guess"
    }, [_c('span', [_vm._v(_vm._s(q.volume))]), _vm._v(" "), _c('span', {
      staticClass: "porm"
    }, [_vm._v("±")]), _vm._v(" "), _c('span', {
      staticClass: "input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.guessUncertainty[index]),
        expression: "guessUncertainty[index]"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.01",
        "name": "guessUncertainty[]",
        "autocomplete": "off",
        "value": "0.00"
      },
      domProps: {
        "value": (_vm.guessUncertainty[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.guessUncertainty, index, $event.target.value)
        }
      }
    }), _c('span', [_vm._v("mL")])])]), _vm._v(" "), _c('button', {
      staticClass: "guess btn",
      on: {
        "click": _vm.submitUncertainty
      }
    }, [_vm._v("Submit Uncertainty")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.finalStep === true),
        expression: "finalStep === true"
      }],
      staticClass: "guesses"
    }, [_c('p', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.secondWrong === false),
        expression: "secondWrong === false"
      }]
    }, [_vm._v("Correct!")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.secondWrong === true),
        expression: "secondWrong === true"
      }]
    }, [_vm._v("Incorrect! The uncertainty value is half of the distance between the markings indicated on the graduated cylinder")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.secondWrong === false),
        expression: "secondWrong === false"
      }]
    }, [_c('div', {
      staticClass: "big"
    }, [_vm._v(_vm._s(q.volume) + "mL ± " + _vm._s(q.uncertainty) + "mL")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.secondWrong === true),
        expression: "secondWrong === true"
      }]
    }, [_c('div', {
      staticClass: "uncertainty-guess"
    }, [_c('span', [_vm._v(_vm._s(q.volume))]), _vm._v(" "), _c('span', {
      staticClass: "porm"
    }, [_vm._v("±")]), _vm._v(" "), _c('span', {
      staticClass: "input wrong"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.guessUncertainty[index]),
        expression: "guessUncertainty[index]"
      }],
      attrs: {
        "disabled": "",
        "type": "number",
        "name": "guessUncertainty[]",
        "autocomplete": "off"
      },
      domProps: {
        "value": (_vm.guessUncertainty[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.guessUncertainty, index, $event.target.value)
        }
      }
    }), _c('span', [_vm._v("mL")])])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentQindex + 1 === _vm.totalQuestions),
        expression: "currentQindex+1 === totalQuestions"
      }]
    }, [_c('button', {
      staticClass: "guess btn final",
      on: {
        "click": _vm.nextQuestion
      }
    }, [_vm._v("Continue "), _c('span', [_vm._v("→")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentQindex + 1 < _vm.totalQuestions),
        expression: "currentQindex+1 < totalQuestions"
      }]
    }, [_c('button', {
      staticClass: "guess btn final",
      on: {
        "click": _vm.nextQuestion
      }
    }, [_vm._v("Next Question "), _c('span', [_vm._v("→")])])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex === _vm.totalQuestions),
      expression: "currentQindex === totalQuestions"
    }],
    staticClass: "outro"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "outro-inner"
  }, [_c('h1', [_vm._v("You completed the quiz!")]), _vm._v(" "), _c('p', [_vm._v("Your final score was "), _c('span', [_vm._v(_vm._s(_vm.currentScore))]), _vm._v(" / " + _vm._s(_vm.totalQuestions * 2) + ". If you scored...")]), _vm._v(" "), _c('ul', [_c('li', {
    class: _vm.currentScore < 13 ? 'scored' : ''
  }, [_vm._v("0–12 points: having a bad day? Ask your teacher for help.")]), _vm._v(" "), _c('li', {
    class: _vm.currentScore >= 13 && _vm.currentScore <= 16 ? 'scored' : ''
  }, [_vm._v("13–16 points: not bad! If you need more practice, try taking the quiz again.")]), _vm._v(" "), _c('li', {
    class: _vm.currentScore > 16 ? 'scored' : ''
  }, [_vm._v("17–20 points: great job! You have great measurement skills.")])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "id": "reset"
    },
    on: {
      "click": _vm.resetEverything
    }
  }, [_vm._v("Start over")])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a53c9f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quiz.vue
// module id = 12
// module chunks = 1